import { UrlConstants } from "../url.constants";
// export class ApiApplicationSummaryConstants {
//   static readonly URL = UrlConstants.API_V2 + "TownPlanning";
// }
export class ApiApplicationStatusConstants {
    static URL = UrlConstants.API_V2 + "Status";
    static FUNCTION_COUNT_STATUS = "GetStatusCount";
    static FUNCTION_OVERDUE_APPLICATIONS = "GetOverdueApplications";
    static FUNCTION_LATEST_APPLICATIONS = "GetLatestApplications";
    static FUNCTION_MULTIPLE_COUNT_STATUS = "GetMultipleStatusCount";
    static FUNCTION_GET_DISTINCT_STATUS = "GetDistinctStatus";
    static FUNCTION_GET_DISTINCT_PERCENT = "GetDistinctPercentComplete";
}
